import { cyan } from '@mui/material/colors'
import { createTheme, lighten } from '@mui/material/styles'

// A custom theme for this app
const theme = createTheme({
  components: {
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingTop: '8px',
          paddingLeft: '8px',
          paddingRight: '8px',
          '&:last-child': {
            paddingBottom: '12px'
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingTop: '4px',
          paddingBottom: '4px',
          paddingLeft: '8px',
          paddingRight: '8px',
          borderLeft: '1px solid rgba(224, 224, 224, 1)',
          borderRight: '1px solid rgba(224, 224, 224, 1)',
          '&:first-of-type': {
            borderLeftWidth: '0px'
          },
          '&:last-of-type': {
            borderRightWidth: '0px'
          }
        }
      }
    }
  },
  palette: {
    background: {
      default: '#fff'
    },
    drawer: {
      light: lighten(cyan[700], 0.5),
      main: 'rgb(0, 75, 83)',
      contrastText: '#fff'
    },
    ricohRed: {
      main: 'rgb(207, 20, 43)',
      contrastText: '#fff'
    },
    ricohBlack: {
      main: 'rgb(48, 50, 51)',
      contrastText: '#fff'
    },
    gray1: {
      main: 'rgb(108, 112, 116)',
      contrastText: '#fff'
    },
    gray2: {
      main: 'rgb(113, 113, 113)',
      contrastText: '#fff'
    },
    gray3: {
      main: 'rgb(184, 184, 184)',
      contrastText: '#fff'
    },
    gray4: {
      main: 'rgb(201, 201, 201)',
      contrastText: '#fff'
    }
  },
  typography: {
    // fontSize: 12
  }
})

export default theme
